import React from 'react'
import intl from 'react-intl-universal'

interface RegenerateAllModalProps {
  handleRegenerate?: () => void
  websitesCount: number
}

export default function RegenerateAllModal({
  handleRegenerate,
  websitesCount,
}: RegenerateAllModalProps) {
  return (
    <div
      className="modal"
      id="regenerateAllCanonicalUrlModal"
      data-testid="regenerateAllCanonicalUrlModal"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {intl.get('canonicalUrl.modal.regenAll.title')}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>
              {intl.formatMessage(
                {
                  id: 'canonicalUrl.modal.regenAll.prompt',
                },
                {
                  websitesCount,
                }
              )}
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              data-dismiss="modal"
            >
              {intl.get('canonicalUrl.modal.buttons.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleRegenerate}
              data-dismiss="modal"
              data-testid="regen-all-confirm-button"
            >
              {intl.get('canonicalUrl.modal.buttons.update')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
